import { FC, Fragment } from "react";
import { useLocation, useNavigate } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import { BreadcrumbsRoute } from "./breadcrumbs.types";
import styles from "./breadcrumbs.module.css";
import { NavLink } from "@remix-run/react";
import { AppLink, makeUrl } from "@commons-monorepo/index";

interface BreadcrumbsProps {
  className?: string;
  routes?: BreadcrumbsRoute[];
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ className, routes }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goBack = (): void => {
    navigate(-1);
  };

  return (
    <div className={`${styles.breadcrumbs} ${className}`}>
      <div className={`${styles.icon} icon`} onClick={goBack}>
        <span className={`${styles.iconArrow} icon-arrow`} />
        <span className={styles.backText}>{t("back")}</span>
      </div>
      <AppLink
        to={makeUrl(pathname, "")}
        className={`${styles.breadcrumbsRoute} breadcrumbs-route`}
        Component={NavLink}>

        {t("home")}
      </AppLink>
      {routes?.map((route) =>
      <Fragment key={`breadcrumbs-route-${route.text}`}>
          <div className={`${styles.divider} divider`}>|</div>
          {!!route.to ?
        <AppLink
          to={route.to}
          className={`${styles.breadcrumbsRoute} breadcrumbs-route`}
          Component={NavLink}>

              {route.text}
            </AppLink> :

        <div className={`${styles.breadcrumbsRoute} breadcrumbs-route`}>
              {route.text}
            </div>}

        </Fragment>
      )}
    </div>);

};

export default Breadcrumbs;